import React, {Component} from 'react'
import PropTypes from 'prop-types'

class ColorspaceDisplay extends Component {
    handleClick = () => {
        const { colorspace, onChange } = this.props
        onChange('colorspace', colorspace)
    }

    render() {
        const { colorspace } = this.props
        return (
            <td className='ColorspaceDisplay'>
                <span className='cursor-pointer' onClick={this.handleClick}>{colorspace ? colorspace.toUpperCase() : '-'}</span>
            </td>
        )
    }
}

ColorspaceDisplay.propTypes = {
    colorspace: PropTypes.string,
    onChange: PropTypes.func.isRequired,
}

export default ColorspaceDisplay
